import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { includes, first, isNil, isEmpty } from 'lodash';
import { Form, Field } from 'react-final-form';
import { Button, Dialog, RadioField, SelectField } from '@unite-us/ui';
import EditButton from '../../common/EditButton';
import Spinner from '../../common/spinners/Spinner';
import { isRequired } from '../../utils/validations';
var MethodsOfContactEdit = function MethodsOfContactEdit(_ref) {
  var contactEnums = _ref.contactEnums,
    initialValues = _ref.initialValues,
    updateContactPreference = _ref.updateContactPreference;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    formErrors = _useState4[0],
    setFormErrors = _useState4[1];
  var methodsOfContactModalRef = useRef(null);
  var openDialog = function openDialog() {
    methodsOfContactModalRef.current.openDialog();
  };
  var closeDialog = function closeDialog() {
    methodsOfContactModalRef.current.closeDialog();
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(formValues, form) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmitting(true);
            _context.next = 3;
            return updateContactPreference(formValues);
          case 3:
            setIsSubmitting(false);
            closeDialog();
            form.reset();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var isPhoneCallSelected;
  var formValidator = {
    dropdownValidate: function dropdownValidate(values) {
      var errors = {};
      isPhoneCallSelected = includes(values === null || values === void 0 ? void 0 : values.preferred_contact_methods, 'phone');
      if (isNil(first(values === null || values === void 0 ? void 0 : values.preferred_contact_methods))) {
        errors.preferred_contact_methods = 'required';
        if (!includes(formErrors, errors.preferred_contact_methods)) {
          setFormErrors(errors);
        }
      }
      return errors;
    },
    voicemailValidate: function voicemailValidate(values) {
      var errors = {};
      isPhoneCallSelected = includes(values === null || values === void 0 ? void 0 : values.preferred_contact_methods, 'phone');
      if (isPhoneCallSelected && isNil(values.voice_mail_ok)) {
        errors.voice_mail_ok = 'Please select yes or no.';
        if (!includes(formErrors, errors.voice_mail_ok)) {
          setFormErrors(errors);
        }
      }
      return errors;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "methods-of-contact-edit"
  }, /*#__PURE__*/React.createElement(EditButton, {
    edit: openDialog,
    labelText: "Edit",
    id: "methods-of-contact-edit-btn",
    "aria-label": "Edit method of contact"
  }), /*#__PURE__*/React.createElement(Form, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    validate: function validate(values) {
      var dropdownValidResponse = formValidator.dropdownValidate(values);
      var voicemailValidResponse;
      if (isEmpty(dropdownValidResponse) && isPhoneCallSelected) {
        voicemailValidResponse = formValidator.voicemailValidate(values);
      }
      return !isEmpty(voicemailValidResponse) && isPhoneCallSelected ? voicemailValidResponse : dropdownValidResponse;
    },
    render: function render(_ref3) {
      var handleSubmit = _ref3.handleSubmit,
        submitting = _ref3.submitting;
      return /*#__PURE__*/React.createElement(Dialog, {
        id: "edit-contact-method",
        onCloseModal: closeDialog,
        onRequestClose: closeDialog,
        ref: methodsOfContactModalRef,
        title: "Edit Methods of Contact",
        type: "form",
        actions: [/*#__PURE__*/React.createElement(Button, {
          id: "edit-methods-contact-cancel-btn",
          onClick: closeDialog,
          disabled: submitting,
          label: "Cancel"
        }), /*#__PURE__*/React.createElement(Button, {
          id: "edit-methods-contact-save-btn",
          disabled: submitting,
          label: "Save",
          primary: true,
          onClick: function onClick() {
            if (!isEmpty(formErrors)) {
              setTimeout(function () {
                var _focusableErr;
                var focusableErr;
                var err = first(document.getElementsByClassName('ui-form-field--has-error'));
                if (err) {
                  var editContactMethodModal = document.getElementById('edit-contact-method');
                  var errInModal = first(editContactMethodModal === null || editContactMethodModal === void 0 ? void 0 : editContactMethodModal.getElementsByClassName('ui-form-field--has-error'));
                  focusableErr = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByTagName('input'));
                }
                if (focusableErr) {
                  focusableErr.ariaLabel = formErrors.voice_mail_ok ? formErrors.voice_mail_ok : formErrors.preferred_contact_methods;
                }
                (_focusableErr = focusableErr) === null || _focusableErr === void 0 || _focusableErr.focus();
                if (!isPhoneCallSelected && includes(formErrors, formErrors.voice_mail_ok)) {
                  setFormErrors({});
                }
              }, 300);
            } else if (first(document.getElementsByClassName('ui-form-field--has-error'))) {
              var editContactMethodModal = document.getElementById('edit-contact-method');
              var errInModal = first(editContactMethodModal === null || editContactMethodModal === void 0 ? void 0 : editContactMethodModal.getElementsByClassName('ui-form-field--has-error'));
              var focusableErr = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByTagName('input'));
              focusableErr === null || focusableErr === void 0 || focusableErr.focus();
            }
            handleSubmit();
          }
        })]
      }, /*#__PURE__*/React.createElement("div", {
        className: "h-56"
      }, isSubmitting ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
        name: "preferred_contact_methods",
        validate: function validate(value) {
          return isRequired(value);
        }
      }, function (props) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "edit-preferred-method-of-contact",
          label: "Methods of Contact",
          multiple: true,
          options: contactEnums,
          placeholder: "Select...",
          required: true,
          shouldSort: false,
          labelKey: "display_name",
          valueKey: "value"
        }, props));
      }), isPhoneCallSelected && /*#__PURE__*/React.createElement(Field, {
        name: "voice_mail_ok",
        parse: function parse(val) {
          return val === 'true';
        } // prevent conversion of bool to string
        ,
        type: "select"
      }, function (props) {
        return /*#__PURE__*/React.createElement(RadioField, _extends({}, props, {
          id: "voice-mail-ok",
          inline: true,
          inlineLabel: true,
          label: "Is it okay to leave voicemail?",
          options: [{
            label: 'Yes',
            value: true
          }, {
            label: 'No',
            value: false
          }],
          required: isPhoneCallSelected
        }));
      }))));
    }
  }));
};
MethodsOfContactEdit.propTypes = {
  initialValues: PropTypes.object.isRequired,
  contactEnums: PropTypes.array.isRequired,
  updateContactPreference: PropTypes.func.isRequired
};
export default MethodsOfContactEdit;
//# sourceMappingURL=MethodsOfContactEdit.js.map